/**
 * Centralized environment variable access utility
 * Primary support for modern VITE_ prefix with legacy REACT_APP_ fallback
 * Falls back to window object for runtime configuration (Docker containers)
 */

export const getHostFromEnv = (url_name, env = import.meta.env) => {
  // Try modern VITE_ prefix first
  const viteKey = `VITE_${url_name}`;
  let host = env[viteKey];

  // Fall back to legacy REACT_APP_ prefix for backward compatibility
  if (!host) {
    const reactKey = `REACT_APP_${url_name}`;
    host = env[reactKey];
  }

  // Fall back to window object (runtime configuration)
  if (!host && typeof window !== "undefined") {
    host = window[viteKey] || window[`REACT_APP_${url_name}`];
  }

  console.log(`Environment variable ${url_name}:`, host);

  if (host != null) return host;
  throw new Error(
    `Missing environment configuration with key '${viteKey}' (legacy: 'REACT_APP_${url_name}')`,
  );
};

// Legacy function for backward compatibility
function getEnvironmentVariable(key) {
  // Modern approach: use getHostFromEnv for both VITE_ and REACT_APP_ variables
  if (key.startsWith("VITE_")) {
    const envName = key.replace("VITE_", "");
    try {
      return getHostFromEnv(envName);
    } catch {
      // Fall back to original logic for any remaining edge cases
    }
  } else if (key.startsWith("REACT_APP_")) {
    const envName = key.replace("REACT_APP_", "");
    try {
      return getHostFromEnv(envName);
    } catch {
      // Fall back to original logic for any remaining edge cases
    }
  }

  // Original fallback logic
  const env =
    (typeof window !== "undefined" ? window[key] : undefined) ||
    import.meta.env[key];
  if (env != null) return env;
  throw new Error(`Missing environment configuration with key '${key}'`);
}

export default getEnvironmentVariable;
